import React from 'react'
import { Button } from '@/atoms/Button'
import { AsH2, AsP, CaptionMD, CaptionSM, TitleLG } from '@/atoms/Text'
import { slugs } from '@/constants'
import { PayItForwardButton } from '@/molecules/PayItForwardButton'
import { useSafeAnalytics } from '@/utils/analytics'

interface NoClaimsAvailableProps {
  onClose: () => void
}

export const NoClaimsAvailable: React.FC<NoClaimsAvailableProps> = ({ onClose }) => {
  const { track } = useSafeAnalytics()

  return (
    <div className="text-center">
      <TitleLG as={AsH2} className="mb-4">
        You haven&apos;t paid it forward yet
      </TitleLG>
      <CaptionMD as={AsP} className="text-gray-500">
        But don’t worry! If you pay it forward before the finale is over you can still qualify for a{' '}
        <span className="text-collectible-blue">Collectible Scene</span> and if you start paying it forward monthly
        before the finale is over you can reserve a <span className="text-collectible-gold">Golden Scene</span>.
      </CaptionMD>
      <CaptionSM as={AsP} className="my-8 text-gray-500">
        Scenes will be distributed in May at our Illuminate 2023 Event.
      </CaptionSM>
      <div className="flex flex-col justify-end gap-4 md:flex-row">
        <Button variant="gray-900" className="justify-center" onClick={onClose}>
          Close
        </Button>
        <PayItForwardButton
          projectSlug={slugs.theChosen}
          target="_blank"
          onClick={() => {
            track('Clicked Pay It Forward From No Claims Available')
          }}
        />
      </div>
    </div>
  )
}
